export default "__VITE_ASSET__81d45fa4__"